import * as React from "react"
import { useContext, useEffect, useState, useRef } from "react";
import { getShapeImages, shapes, CUSTOM_IMAGE_SHAPE } from "./ShapeItems";
import { Context } from "../../../../Context/context";
import { ShapeItem, ShapeSetting } from "../../../../TypesAndConstants/types";

interface SliderItemProp {
    sliderItem: ShapeItem,
    index: number,
    setShape: ( slideterItem: ShapeItem, target: HTMLElement ) => void;
}
function SliderItem ({ sliderItem, setShape, index }: SliderItemProp ) {
  return ( 
      <span
        key={ index }
        id={"mobileShape_"+index}
        className={"shapeItem"}
        style={{
          padding: "10px",
          margin: "10px",
        }}
      >
        <div
          key={sliderItem.shape}
          onClick={(event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
            setShape(sliderItem, ( event.target as HTMLElement ).parentNode as HTMLElement);
            event.preventDefault();
            return false;
          }}
          style={{
            height: "50px",
            width: "50px",
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundImage: `url("${sliderItem.url}")`,
          }}
        />
      </span>
    );
};


export default function ShapeGallery( ){
  const {
    state: {
      shapeImages,
      images,
      shapeSettings
    },
    dispatch,
  } = useContext(Context);
  const [ imageItems, setImageItems ] = useState<ShapeItem[]>([]);
  const currentEl = useRef<HTMLElement|null>(null)
  const setShape = ( sliderItem: ShapeItem, element: HTMLElement ):void => {
    if( currentEl.current && currentEl.current !== element ) {
      currentEl.current.classList.remove('active')
    }
    element.classList.add('active')
    currentEl.current = element;

    const shape: ShapeSetting = {
      shape: sliderItem.shape,
      imageIndex: sliderItem.imageIndex,
      shapeSize: shapeSettings.shapeSize,
      shapeRotation: shapeSettings.shapeRotation,
    };
    dispatch({ type: "set_shape", value: shape });
  };


  useEffect(()=> {
    const _images =  getShapeImages(shapeImages, images);
    setImageItems( _images );
  }, [images, shapeImages])

  return (
    <div
      style={{
        margin: "10px",
        display: "flex",
        flexWrap: "wrap",
        maxHeight: "45vh",
        overflow: "auto",
      }}
    >
    <style>{`
      .shapeItem {
        cursor: pointer;
        border: 1px solid black;
      }
      .shapeItem.active{
        border: 2px solid #ff005e !important;
      }
    `}
    </style>
      { imageItems.map((item, index) => <SliderItem key={index} sliderItem={item} index={ ( CUSTOM_IMAGE_SHAPE + index) } setShape={ setShape } /> )  }
      { shapes.map( (item, index ) => <SliderItem key={(100 + index)} sliderItem={item} index={item.shape} setShape={ setShape } /> )  }
    </div>
  );
};
